import Reveal from "../Reveal";
import { FAQS } from "../../lib/site";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq" className="bg-sand py-24 md:py-32">
      <div className="mx-auto grid max-w-[1400px] gap-12 px-6 md:px-12 lg:grid-cols-[0.9fr_1.1fr]">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.25em] text-gold">Questions</p>
          <h2 className="mt-4 font-heading text-4xl font-extrabold tracking-tight text-forest md:text-5xl">
            Everything you wanted to ask about going solar.
          </h2>
          <p className="mt-5 max-w-sm text-moss">Still unsure? Chat with Ray, our solar assistant, in the bottom-right corner — or request a callback.</p>
        </Reveal>
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-${i}`} className="border-t border-line last:border-b">
                <AccordionTrigger className="py-5 text-left font-heading text-lg font-bold text-forest hover:no-underline">{f.q}</AccordionTrigger>
                <AccordionContent className="pb-5 text-base leading-relaxed text-moss">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
